/* @flow */
import * as F from 'lodash/fp';
import * as React from 'react';
import styled from 'styled-components';

import { Box, Button } from '@sonyged/proc-ui';
import css from '@styled-system/css';

import type { Customer } from '../rules/types';
import { CustomerIcon } from './CustomerIcon';

type Props = {
  customer: { ...Customer },
  onClick: Function,
  children: React.Node,
  disabled?: boolean,
};

export function CustomerDataPill(props: Props) {
  const { disabled, children, customer, onClick, ...rest } = props;

  const handleClick = React.useCallback(() => {
    onClick(customer);
  }, [onClick, customer]);

  return (
    <Container {...rest}>
      <Avatar disabled={disabled} customer={customer} />
      <PillButton disabled={disabled} onClick={handleClick}>
        {children}
      </PillButton>
    </Container>
  );
}

const height = [36, 36, 48];
const avatarSize = [26, 26, 32];
const avatarMargin = F.zip(height, avatarSize).map(([h, s]) => (h - s) / 2);
const textMargin = F.zipAll([avatarMargin, avatarSize, [3, 3, 8]]).map(F.sum);

const Container = styled(Box)(
  css({
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
    width: [100, 100, 140],
  })
);

const Avatar = styled(CustomerIcon)(
  css({
    position: 'absolute',
    top: avatarMargin,
    left: avatarMargin,
    borderRadius: 9999,
    size: avatarSize,
    bg: '#ecf2f9',
    pointerEvents: 'none',
  }),
  ({ disabled }) => disabled && { opacity: 0.3 }
);

const PillButton = styled(Button).attrs({ variant: 'outline' })(
  css({
    height,
    width: '100%',
    pr: 0,
    pl: textMargin,
    textAlign: 'left',
    bg: '#fff',
    fontSize: [14, 14, 20],
  })
);
